jQuery(document).ready(function($) {
				$('.news-inner .newsletter-item .newsletter-content .left .newsletter-date').html(function(){
 					var text = $(this).text().split(' ');
 					var first = text.shift();
 					return (text.length > 0 ? '<span class="first">'+first+'</span> ' : first) + text.join(" ");
 				});
				$('.news .news-entry-content .calendar-wrapper .google-calendar .fc-header-toolbar .fc-center h2').html(function(){
					var text = $(this).text().split(' ');
					var first = text.shift();
					return (text.length > 0 ? '<span class="first">'+first+'</span> ' : first) + text.join(" ");
				});


				$('.calendar .news-entry-content .calendar-wrapper .fc-event-container a[href="#"]').on('click', function(e) {
				    e.preventDefault();
				});

})
